import Vue from 'vue'
import Router from 'vue-router'
import SeaTree from '@/components/SeaTree'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'SeaTree',
      component: SeaTree
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js